<template>
  <li :class="liClass" @click="emitClick">
    <span :class="spanClass">
      <slot></slot>
    </span>
  </li>
</template>

<script lang="ts" setup>
/**
 * @deprecated
 *
 * Please use `cl-raised-tab` instead.
 */
import { toRefs, computed } from "vue";

export interface DropdownItemProps {
  active?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<DropdownItemProps>(), {
  active: false,
  disabled: false,
});

const { active, disabled } = toRefs(props);

const liClass = computed(() => {
  return [
    "tw-mb-2 tw-mr-4 tw-select-none",
    disabled.value
      ? "tw-pointer-events-none tw-text-dorian-gray-200"
      : "tw-text-dorian-gray-500 hover:tw-cursor-pointer",
    active.value ? "hover:tw-cursor-default" : "hover:tw-cursor-pointer",
  ];
});

const spanClass = computed(() => {
  return [
    "tw-inline-block tw-border-b-2 tw-text-base tw-font-medium",
    active.value
      ? "tw-border-secondary-500 tw-text-secondary-500 hover:tw-cursor-default"
      : "tw-border-secondary-500/0 hover:tw-border-secondary-500",
  ];
});

const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};
</script>

<style scoped></style>
